/**
 * PresentationTitle React component
 * 
 * @author    Jens Gruschel
 * @copyright © 2020 contexagon GmbH
 */


import React from 'react';
import PropTypes from 'prop-types';
import AnimatedUpdate from "../../animation/AnimatedUpdate";
import {getStandardAnimate, getStandardTransition} from "./animationUtils";


/**
 * presentation title view
 *
 * @author Jens Gruschel
 */
function PresentationTitle(props) {

    const {className, title, subheading} = props;

    // split the subheading in two lines after first line break
    let subheadingFirstLine, subheadingSecondLine = "";
    if (subheading) {
        const subheadingLines = subheading.split("\n");
        subheadingFirstLine = subheadingLines.slice(0, 1).join("");
        subheadingSecondLine = subheadingLines.slice(1).join("\n");
    }

    return <div className={className}>
        <AnimatedUpdate tag={title} animate={getStandardAnimate()} transition={getStandardTransition(0)}>
            <div className="presentation-title"><p>{title}</p></div>
        </AnimatedUpdate>
        <AnimatedUpdate tag={subheading} animate={getStandardAnimate()} transition={getStandardTransition(0.5)}>
            <div className="presentation-subtitle">{subheadingFirstLine}</div>
            <div className="presentation-subtitle">{subheadingSecondLine}</div>
        </AnimatedUpdate>
    </div>;
}

PresentationTitle.propTypes = {
    title: PropTypes.string,
    subheading: PropTypes.string
};

export default PresentationTitle;
